import { apiSlice } from './apiSlice';
import {
  User,
  LoginCredentials,
  RegisterData,
  AuthTokens,
  ApiResponse,
  Role,
  Wallet,
} from '@/types';
import { setUser, UserResponse } from '../slices/userSlice';
import { setAvailableRoles } from '../slices/availableRolesSlice';
interface ChangePasswordResponse {
  status: number;
  message: string;
}
export interface LoginResponse {
  success?: boolean;
  accessToken: string | null;
  type?: string;
  role?: {
    name: string;
    id: number;
  };
  transactionCode?: string | null;
  passwordChanged?: boolean;
  isSelfRegistered?: boolean;
  createdBy?: string;
  mfaRequired?: boolean;
  mfaMethod?: string;
  mfaToken?: string;
}
export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<
      LoginResponse,
      {
        username: string;
        password: string;
        // captchaId: string;
        // captchaText: string;
      }
    >({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    verifyMfa: builder.mutation<LoginResponse, { mfaToken: string; token: string }>({
      query: (body) => ({
        url: '/auth/mfa/verify',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    // new captcha endpoint
    getCaptcha: builder.query<any, void>({
      query: () => ({
        url: '/captcha',
        method: 'POST',
      }),
    }),

    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),
    getUser: builder.query<UserResponse, void>({
      query: () => ({ url: '/users/me', method: 'GET', params: { ts: Date.now() } }),

      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setUser(data));
        } catch (err) {
          console.error(err);
        }
      },
      providesTags: ['User'],
    }),
    availbleRoles: builder.query<Role[], void>({
      query: () => ({
        url: '/role/available',
        method: 'GET',
        params: { ts: Date.now() },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAvailableRoles(data));
        } catch (err) {
          console.error(err);
        }
      },
      // providesTags: ['User'],
    }),
    changePassword: builder.mutation<
      { success: boolean; status?: string },
      { oldPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: '/users/me/change-password',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    OwnerChangePassword: builder.mutation<
      ChangePasswordResponse,
      { oldPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: '/admin/change-password',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),

    getWallet: builder.query<Wallet[], void>({
      query: () => ({
        url: '/users/me/wallets',
        method: 'GET',
        params: { ts: Date.now() },
      }),
      providesTags: ['Wallet'],
    }),
  }),
});

export const {
  useLoginMutation,
  useVerifyMfaMutation,
  useGetCaptchaQuery,
  useLazyGetCaptchaQuery,
  useLogoutMutation,
  useGetUserQuery,
  useChangePasswordMutation,
  useAvailbleRolesQuery,
  useGetWalletQuery,
  useOwnerChangePasswordMutation,
} = authApi;
